"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _UIFlex = _interopRequireDefault(require("../layout/UIFlex"));

var _UILink = _interopRequireDefault(require("../link/UILink"));

var _UIClickable = _interopRequireDefault(require("../button/UIClickable"));

var _Selectors = require("../constants/Selectors");

var _decorators = require("../utils/propTypes/decorators");

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _FocusProvider = _interopRequireDefault(require("../providers/FocusProvider"));

var USE_CLASSES = {
  default: '',
  'full-card': 'private-hoverlay--full-card',
  'bottom-half-card': 'private-hoverlay--bottom-half-card'
};

var UIHoverlay = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIHoverlay, _Component);

  function UIHoverlay() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIHoverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIHoverlay)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      hasTabbableContent: false
    };

    _this.refCallback = function (el) {
      if (!el) return;
      var hasTabbableContent = el.querySelector(_Selectors.FOCUSABLE);

      _this.setState({
        hasTabbableContent: hasTabbableContent
      });
    };

    return _this;
  }

  (0, _createClass2.default)(UIHoverlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _blur = _this$props._blur,
          className = _this$props.className,
          children = _this$props.children,
          __focused = _this$props.focused,
          foregroundContent = _this$props.foregroundContent,
          __hovered = _this$props.hovered,
          href = _this$props.href,
          linkComponent = _this$props.linkComponent,
          onClick = _this$props.onClick,
          overlayClassName = _this$props.overlayClassName,
          tabIndex = _this$props.tabIndex,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["_blur", "className", "children", "focused", "foregroundContent", "hovered", "href", "linkComponent", "onClick", "overlayClassName", "tabIndex", "use"]);
      var hasTabbableContent = this.state.hasTabbableContent;

      if (process.env.NODE_ENV !== 'production') {
        if (href && onClick) {
          _devLogger.default.warn({
            message: 'UIHoverlay: Cannot have both onClick and href props.'
          });
        }
      }

      return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
        return _react.default.createElement(_FocusProvider.default, _this2.props, function (focusProviderProps) {
          var hovered = hoverProviderProps.hovered,
              hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
          var focused = focusProviderProps.focused,
              focusProviderRestProps = (0, _objectWithoutProperties2.default)(focusProviderProps, ["focused"]);
          var wrappedForegroundContent = foregroundContent == null ? null : _react.default.createElement("div", {
            className: (0, _classnames.default)(overlayClassName, 'uiOverlay-backdrop', 'private-hoverlay__overlay', 'private-overlay--contextual', {
              'private-hoverlay__overlay--clickable': href || onClick,
              'private-hoverlay__overlay--focused': focused,
              'private-hoverlay__overlay--hovered': hovered
            })
          }, _react.default.createElement(_UIFlex.default, {
            align: "stretch",
            direction: "column",
            justify: "start",
            className: (0, _classnames.default)('private-overlay__overlay-content', 'private-hoverlay__foreground-content')
          }, foregroundContent));

          var renderedOverlay = _react.default.createElement("span", null, wrappedForegroundContent, _react.default.createElement("div", {
            className: (0, _classnames.default)('private-hoverlay__children', {
              'private-hoverlay__children--blur': _blur
            }, {
              'private-hoverlay--blur': _blur
            })
          }, (0, _react.cloneElement)(children, {
            className: (0, _classnames.default)('private-hoverlay__child', children.props.className)
          })));

          var renderedHoverlay;

          if (href) {
            renderedHoverlay = CustomRenderer.render(linkComponent, {
              children: renderedOverlay,
              className: 'display-block',
              href: href,
              use: 'unstyled'
            });
          } else if (onClick) {
            renderedHoverlay = _react.default.createElement(_UIClickable.default, {
              className: "private-hoverlay__button",
              onClick: onClick
            }, renderedOverlay);
          } else {
            renderedHoverlay = renderedOverlay;
          }

          var computedTabIndex;

          if (tabIndex != null) {
            computedTabIndex = tabIndex;
          } else {
            computedTabIndex = hasTabbableContent ? null : 0;
          }

          return _react.default.createElement("div", (0, _extends2.default)({}, rest, hoverProviderRestProps, focusProviderRestProps, {
            className: (0, _classnames.default)(className, 'private-hoverlay', USE_CLASSES[use], {
              'is--module': use === 'full-card'
            }),
            ref: _this2.refCallback,
            tabIndex: computedTabIndex
          }), renderedHoverlay);
        });
      });
    }
  }]);
  return UIHoverlay;
}(_react.Component);

UIHoverlay.propTypes = {
  _blur: _propTypes.default.bool,
  children: _propTypes.default.element,
  focused: (0, _decorators.hidden)(_propTypes.default.bool),
  foregroundContent: _propTypes.default.node,
  hovered: _propTypes.default.bool,
  href: _propTypes.default.oneOfType([_validHref.default]),
  linkComponent: CustomRenderer.propType,
  overlayClassName: _propTypes.default.string,
  use: _propTypes.default.oneOf(Object.keys(USE_CLASSES))
};
UIHoverlay.defaultProps = {
  _blur: true,
  linkComponent: _UILink.default,
  use: 'default'
};
UIHoverlay.displayName = 'UIHoverlay';
var _default = UIHoverlay;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/overlay/UIHoverlay.js
// module id = 884
// module chunks = 209 210 211 212